import { Injectable, EventEmitter } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Observable, Subscription, BehaviorSubject } from 'rxjs'

import { environment } from "../../environments/environment"
import { User } from '../shared/security/user.model';
import { Session } from './app.model';
import { StorageService } from '../shared/storage.service';
import { AuthService } from '../shared/security/auth.service';
import { Form, FormGroup } from '@angular/forms';
export let isDebugMode = environment.isDebugMode

@Injectable()
export class AppService {

    private subscriptions: Subscription[] = []
    public title: BehaviorSubject<string> = new BehaviorSubject<string>(null)
    public breadCrumb: BehaviorSubject<string> = new BehaviorSubject<string>(null)
    
    eventItemLoad = new EventEmitter<any>()
    eventSelect = new EventEmitter<any>()
    eventClick = new EventEmitter<any>()
    eventSession = new EventEmitter<Session>()
    eventProgress = new EventEmitter<any>()
    eventSideBarExpand = new EventEmitter<boolean>()
    eventOpenDetail = new EventEmitter<boolean>()
    session: Session    
    viewid: number = 0 //usado para mostrar a view no modal
    tableid: string //usado para o file upload
    recidkey: string //usado para o file upload
    
    //breadcrumb: string = "Home / Products"
    progressTax: any = {
        orderid: 0,
        progress: 45
    }

    constructor(
        private http: HttpClient,
        private auth: AuthService,
        private storageService: StorageService
    ) {
        isDebugMode ? console.log(`constructor()`) : undefined
        if (this.auth.loggedIn) {
            this.session = <Session>this.storageService.getObject("session")
            this.eventSession.emit(this.session)
        } else {
            this.session = new Session()
            this.storageService.setObject("session", this.session)
        }
    }

    getPassport(): Observable<any> {
        return this.http.post<any>(`${environment.api}/jwt/passport`, {})
    }

    getUser(): Observable<User> {
        isDebugMode ? console.log(`getUser()`) : undefined
        //console.log(this.session)
        return this.http.get<any>(`${environment.api}/users/${this.session.userid}`)
    }

    getUserMenu(parent: number): Observable<any> {
        isDebugMode ? console.log(`getUser()`) : undefined
        //console.log(this.session)
        return this.http.get<any>(`${environment.api}/users/${this.session.userid}/menuitem/${parent}`)
    }


    setUser(): Observable<any> {
        isDebugMode ? console.log(`setUser()`) : undefined

        return this.http.put<any>(
            `${environment.api}/users/${this.session.userid}`,
            {
                details: [{
                    userid: this.session.userid,
                    session: `{"groupid": ${this.session.groupid}, "themeid": ${this.session.themeid}}`
                }]
            }

        )


    }

    setTitle(value: string) {
        this.title.next(value)
    }

    setBreadcrumb(value) {
        this.breadCrumb.next(value)
    }


    getData(tableid: any, formData: any, keys: any): Observable<any> {
        isDebugMode ? console.log(`getUser()`) : undefined

        console.log('aqui',  keys )

        let _keys = []

        let groupid: any = this.session.groupid

        if (keys) {
            Object.keys(keys).forEach(key => {
                if (keys[key]) {
                    _keys.push({ key: key, value: keys[key] })
                }
            })
        }

        Object.keys(formData).forEach(key => {
            if (formData[key]) {
                _keys.push({ key: key, value: formData[key] })
            }
        })

        let httpHeaders = new HttpHeaders()
            .set('groupid', groupid)
            .set('tableid', tableid);

        let options = {
            headers: httpHeaders
        };

        console.log('aqui', environment.api, _keys )


        return this.http.post<any>(
            `${environment.api}/get`
            , { keys: _keys }
            , { headers: httpHeaders }

        )

    }

    pad(n, width, z) {
        z = z || '0';
        n = n + '';
        return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
    }

    typeRegisterCode(registercode) {

        let _registercode = registercode.replace(/(\.|\/|\-)/g, "").replace(/ /g, "")

        if (_registercode.length < 12) {
            return 2
        }

        return 1

    }

    formatRegisterCode(registercode) {

        let _registercode = registercode.replace(/(\.|\/|\-)/g, "").replace(/ /g, "")

        if (_registercode.length < 12) {
            _registercode = this.pad(_registercode, 11, '0')
            _registercode = _registercode.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "\$1.\$2.\$3\-\$4")
        } else {
            _registercode = this.pad(_registercode, 14, '0')
            _registercode = _registercode.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, "\$1.\$2.\$3\/\$4\-\$5")
        }

        return _registercode

    }

    validRegisterCode(registercode) {

        if (!registercode) {
            return false
        }

        registercode = registercode.replace(/(\.|\/|\-)/g, "").replace(/ /g, "")

        if (registercode.length < 12) {

            if (registercode == "00000000000"
                || registercode == "11111111111"
                || registercode == "22222222222"
                || registercode == "33333333333"
                || registercode == "44444444444"
                || registercode == "55555555555"
                || registercode == "66666666666"
                || registercode == "77777777777"
                || registercode == "88888888888"
                || registercode == "99999999999") {
                return false
            }

            let soma = 0

            let resto

            for (var i = 1;i <= 9;i++) {
                soma = soma + parseInt(registercode.substring(i - 1, i)) * (11 - i)
            }
            resto = (soma * 10) % 11

            if ((resto == 10) || (resto == 11))
                resto = 0

            if (resto != parseInt(registercode.substring(9, 10))) {
                return false
            }

            soma = 0

            for (var i = 1;i <= 10;i++) {
                soma = soma + parseInt(registercode.substring(i - 1, i)) * (12 - i)
            }

            resto = (soma * 10) % 11

            if ((resto == 10) || (resto == 11)) {
                resto = 0
            }

            if (resto != parseInt(registercode.substring(10, 11))) {
                return false
            }

            return true

        } else {

            if (registercode == "00000000000000"
                || registercode == "11111111111111"
                || registercode == "22222222222222"
                || registercode == "33333333333333"
                || registercode == "44444444444444"
                || registercode == "55555555555555"
                || registercode == "66666666666666"
                || registercode == "77777777777777"
                || registercode == "88888888888888"
                || registercode == "99999999999999") {
                return false
            }

            let tamanho = registercode.length - 2

            let numeros = registercode.substring(0, tamanho)

            let digitos = registercode.substring(tamanho)

            let soma = 0

            let pos = tamanho - 7

            for (var i = tamanho;i >= 1;i--) {
                soma += numeros.charAt(tamanho - i) * pos--
                if (pos < 2) pos = 9
            }

            var resultado = soma % 11 < 2 ? 0 : 11 - soma % 11

            if (resultado != digitos.charAt(0)) {
                return false;
            }

            tamanho = tamanho + 1

            numeros = registercode.substring(0, tamanho)

            soma = 0

            pos = tamanho - 7

            for (var i = tamanho;i >= 1;i--) {
                soma += numeros.charAt(tamanho - i) * pos--
                if (pos < 2) pos = 9
            }

            resultado = soma % 11 < 2 ? 0 : 11 - soma % 11

            if (resultado != digitos.charAt(1)) {
                return false
            }

            return true

        }


    }

    getCNAE(cnaeid : string): Observable<any> {
        isDebugMode ? console.log(`setUser()`) : undefined

        return this.http.get<any>(
            `${environment.api}/${this.session.groupid}/customers/cnae/${cnaeid}/get`
        )


    }


    readMsg(messages): Observable<any> {
        isDebugMode ? console.log(`setUser()`) : undefined

        return this.http.post<any>(
            `${environment.api}/${this.session.groupid}/msg/read`,
            messages
        )


    }



}